module.exports = __webpack_public_path__ + "static/media/menu.337d4ab0.png";